import React from 'react';
import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material';
import { TitleEntity, VersionGroupedByParent } from '@/redux/slices/slice_types';
import { TitleTypeLabel, TitleVersionChip } from '@/exports/columnCommonComponents';
import { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';
import { isObjectAVersion } from './utils';

interface EntryProps {
  version: TitleEntity;
  sequenceOrder?: string | number;
}

const Entry: React.FC<EntryProps> = ({ version, sequenceOrder }) => (
  <Grid container alignItems="center" sx={{ py: 0.5 }}>
    <Grid item maxWidth="50%">
      <Typography sx={{ wordBreak: 'break-all' }}>E{sequenceOrder || '?'}</Typography>
    </Grid>
    <Grid item flex="auto">
      <Divider sx={{ borderColor: 'action.selected', borderStyle: 'dashed', mx: 2 }} />
    </Grid>
    <Grid item>
      <TitleVersionChip version={version} size="small" withTooltip />
    </Grid>
  </Grid>
);

interface Props {
  movie: TitleEntity | TitleEntityV2;
  movieChildren: VersionGroupedByParent;
  parentYear?: number;
}

const Movie: React.FC<Props> = ({ movie, movieChildren, parentYear }) => {
  return (
    <Card elevation={0}>
      <CardHeader
        title={
          <Grid container alignItems="center">
            <Grid item sx={{ display: 'flex', alignItems: 'center', maxWidth: '70%' }}>
              <Typography>
                {movie.name}
                {!!parentYear && (
                  <Typography variant="caption" sx={{ ml: 0.5 }}>
                    ({parentYear})
                  </Typography>
                )}
              </Typography>
            </Grid>
            <Grid item sx={{ ml: 'auto' }}>
              <TitleTypeLabel type={movie.entity_type} />
            </Grid>
          </Grid>
        }
      />
      <CardContent sx={{ pb: 0, pt: 2 }}>
        <Box>
          {Object.keys(movieChildren).map((mId) => {
            const mc = movieChildren[mId];

            if (isObjectAVersion(mc)) {
              return <Entry key={mId} version={mc} sequenceOrder={movie.sequence_order} />;
            }

            return Object.keys(mc).map((mcId) => {
              const mcc = mc[mcId];
              return isObjectAVersion(mcc) ? <Entry key={mcId} version={mcc} sequenceOrder={movie.sequence_order} /> : null;
            });
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Movie;
